import React from 'react'
import './FileComplaint.css'
import {Link} from "react-router-dom";

function FileComplaint() {
  return (
      <main className='main'>
        <section className='file-complaint-section section container'>
          <h1 className='section-title'>File a complaint</h1>
          <p>
            All disputes with an Operator whether they be about a deposit, a payout, a blocked account, any delay, and
            so on, should first be taken up directly with the Operator. These complaints must be filed using the form
            embedded on the site seal validation page of the specific operator. If no resolution is found, the matter,
            depending on the details of the complaint, may be escalated to Anjouan Gaming. Doing so indicates and
            confirms your agreement to and acceptance of the terms and conditions of the complaint handling. When using
            this process you will be given the opportunity to present any information regarding your claim, we will then
            also provide the operator with the opportunity to respond. Once both parties have provided their information
            regarding the claim, we will review and make a determination. Parties accept that the outcome of our
            decision in the matter is final and forfeit the right to take the other party to court. Note, all
            information and communications must be in English.
          </p>

          <p>
            Only once we receive all of the information and supporting documentation can we initiate our evaluation of
            the claim/dispute and if appropriate the dispute process. Incomplete claims will not be considered.
          </p>

          <p>
            You must accept the <Link to='/dispute-terms-conditions' className='href' style={{color: 'blue'}}>Dispute Terms &amp; Conditions</Link> in order to proceed and file your dispute.
          </p>
        </section>
      </main>
  )
}

export default FileComplaint